module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-guest-book-c3f777f32ab8a611b61de5f6bf73d4eb.jpg";